import React, { useEffect, useState } from 'react'
import styles from './BillingDetails.module.css'
import Text from '../../../components/text/Text'
import arrowBack from '../../../assets/icons/icons-arrow-back.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import routes from '../../../router/routes'
import { getInvoiceDocument } from '../../../services/billing'
import { format } from 'date-fns'
import { currencyFormat } from '../../../formatters'

interface CardItem {
    title?: boolean
    label: string
    value: string
}

interface CardSection {
    items: CardItem[]
}

interface Card {
    title: string
    sections: CardSection[]
}

export function BillingDetails() {
    const navigation = useNavigate()
    const [data, setData] = useState<Card[]>([])

    const { search } = useLocation()

    useEffect(() => {
        const query = new URLSearchParams(search)
        const nDocumento = query.get('nDocumento')
        const nConciliacion = query.get('nConciliacion')
        const tipoDocumento = query.get('tipoDocumento')
        const tipoMovimiento = query.get('tipoMovimiento')

        getInvoiceDocument({
            nDocumento: nDocumento || '',
            nConciliacion: nConciliacion || '',
            tipoDocumento: tipoDocumento || '',
            tipoMovimiento: tipoMovimiento || '',
        }).then((success) => {
            if (success.statusCodeValue === 200) {
                setData(
                    success.body.data.detalleMovimientos.map((i: any) => ({
                        title: i.tipoMovimiento,
                        sections: [
                            {
                                items: [
                                    {
                                        title: true,
                                        label: 'Fecha',
                                        value: 'Tipo de movimiento',
                                    },
                                    {
                                        title: false,
                                        label: format(
                                            new Date(i.fecha),
                                            'dd-MM-yyyy'
                                        ),
                                        value: i.tipoMovimiento,
                                    },
                                ],
                            },
                            {
                                items: [
                                    {
                                        title: true,
                                        label: 'N* de documento',
                                        value: 'Abono',
                                    },
                                    {
                                        title: false,
                                        label: Number(i.nDocumento).toFixed(0),
                                        value: i.abonos
                                            ? currencyFormat(i.abonos)
                                            : '-',
                                    },
                                ],
                            },
                            {
                                items: [
                                    {
                                        title: true,
                                        label: 'Cargo',
                                        value: i.cargos
                                            ? currencyFormat(i.cargos)
                                            : '-',
                                    },
                                ],
                            },
                        ],
                    }))
                )
            }
        })
    }, [])

    const handleGoBack = () => {
        navigation(`/${routes.billing}/${routes.billingMain}`)
    }

    const Card = ({ title, sections }: Card) => {
        return (
            <div className={styles.cardFacturacionDetails}>
                <Text
                    label={title}
                    fontSize={14}
                    color="#000000"
                    fontWeight={600}
                    marginBottom={25}
                />
                {sections.map((item, index) => (
                    <Section key={index} items={item.items} />
                ))}
            </div>
        )
    }

    const Section = ({ items }: CardSection) => {
        return (
            <div className={styles.cardFacturacionDetailsSection}>
                {items.map((item, index) => (
                    <Item key={index} properties={item} />
                ))}
            </div>
        )
    }

    const Item = ({ properties }: { properties: CardItem }) => {
        if (properties.title) {
            return (
                <div className={styles.cardFacturacionDetailsItem}>
                    <Text
                        label={properties.label}
                        fontSize={12}
                        color="#000000"
                        fontWeight={600}
                    />
                    <Text
                        label={properties.value}
                        fontSize={12}
                        color="#000000"
                        fontWeight={600}
                    />
                </div>
            )
        } else {
            return (
                <div className={styles.cardFacturacionDetailsItem}>
                    <Text
                        label={properties.label}
                        fontSize={12}
                        color="#000000"
                        fontWeight={400}
                    />
                    <Text
                        label={properties.value}
                        fontSize={12}
                        color="#000000"
                        fontWeight={400}
                    />
                </div>
            )
        }
    }

    return (
        <div className={styles.sectionFacturacionDetails}>
            <div className={styles.header}>
                <img
                    src={arrowBack}
                    onClick={handleGoBack}
                    className={styles.back}
                />
                <Text
                    fontSize={20}
                    marginLeft={15}
                    color="#656565"
                    fontWeight={600}
                    label="Detalle Documento"
                />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0px 50px' }}>
                {data.map((item, index) => (
                    <Card
                        key={index}
                        title={item.title}
                        sections={item.sections}
                    />
                ))}
            </div>
        </div>
    )
}
